// Collection filtering behaviour.
//
// The filter panel is a GET <form> (sidebar on desktop, slide-in drawer on
// mobile). This script:
//   - opens/closes the mobile drawer (toggle button, close button, backdrop,
//     Escape key) with a body scroll-lock
//   - on desktop, auto-submits the form when a filter changes (progressive
//     enhancement); mobile batches changes behind the "Apply" button
//
// Everything degrades gracefully without JS: the panel stays visible and the
// "Apply" button submits the form.

function initCollectionFilters() {
  const form = document.querySelector('[data-filter-form]');
  if (!form) return;

  const openBtn = document.querySelector('[data-filter-open]');
  const closeBtn = document.querySelector('[data-filter-close]');
  const backdrop = document.querySelector('[data-filter-backdrop]');
  const OPEN_CLASS = 'collection-filters-open';

  function openDrawer() {
    document.body.classList.add(OPEN_CLASS);
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    document.body.classList.remove(OPEN_CLASS);
    if (openBtn) {
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.body.classList.contains(OPEN_CLASS)) {
      closeDrawer();
    }
  });

  // Desktop: apply filters immediately on change. Mobile keeps the drawer
  // open and waits for the explicit "Apply" tap.
  const desktop = window.matchMedia('(min-width: 1024px)');
  form.addEventListener('change', () => {
    if (desktop.matches) form.submit();
  });
}

// Collapsible collection description ("Read more"). Progressive enhancement:
// without JS the full description shows (no html.js → no CSS clamp) and the
// toggle stays hidden.
function initCollectionAbout() {
  const about = document.querySelector('[data-collection-about]');
  if (!about) return;

  const desc = about.querySelector('[data-collection-description]');
  const toggle = about.querySelector('[data-collection-about-toggle]');
  if (!desc || !toggle) return;

  // The description is already clamped at first paint (CSS, html.js) so there's
  // no post-load shift. Reveal the toggle only if the text actually overflows
  // the clamp; for short text, expand it (un-clamp) and leave the toggle hidden.
  if (desc.scrollHeight - desc.clientHeight > 2) {
    toggle.hidden = false;
  } else {
    about.setAttribute('data-expanded', '');
  }

  toggle.addEventListener('click', () => {
    const expanded = about.toggleAttribute('data-expanded');
    toggle.textContent = expanded ? toggle.dataset.less : toggle.dataset.more;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });
}

function initCollection() {
  initCollectionFilters();
  initCollectionAbout();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollection);
} else {
  initCollection();
}
